<template>
  <section class="datatable__container">
    <transition-group>
      <datatable
        class="datatable__table"
        key="datatabelReportsExams"
        :columns="columns"
        :data.sync="rows"
        v-if="rows.length > 0"
      >
        <template slot-scope="{ row }">
          <tr class="datatable__row">
            <td
              v-for="(rowVal, rowName, index) in row"
              :key="`examsReport_${index}`"
              class="datatable__cell"
            >
              {{ rowVal }}
            </td>
          </tr>
        </template>
      </datatable>

      <h2 class="datatable__no-data" key="no-data" v-if="rows.length === 0">
        Não há dados.
      </h2>
    </transition-group>
  </section>
</template>

<script>
export default {
  props: {
    columns: Array,
    rows: Array
  }
}
</script>
